var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7513 15.0304C15.7513 14.3824 16.2731 13.8571 16.9168 13.8571H18.772C19.4157 13.8571 19.9375 14.3824 19.9375 15.0304V16.8981C19.9375 17.5461 19.4157 18.0714 18.772 18.0714H16.9168C16.2731 18.0714 15.7513 17.5461 15.7513 16.8981V15.0304Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87567 18.959C7.87567 18.311 8.39747 17.7857 9.04113 17.7857H10.8964C11.54 17.7857 12.0618 18.311 12.0618 18.959V20.8267C12.0618 21.4747 11.54 22 10.8964 22H9.04113C8.39746 22 7.87567 21.4747 7.87567 20.8267V18.959Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.0304C0 14.3824 0.521797 13.8571 1.16547 13.8571H3.0207C3.66437 13.8571 4.18617 14.3824 4.18617 15.0304V16.8981C4.18617 17.5461 3.66437 18.0714 3.0207 18.0714H1.16547C0.521797 18.0714 0 17.5461 0 16.8981V15.0304Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18617 6.96956C4.18617 7.61756 3.66437 8.14286 3.0207 8.14286H1.16547C0.521798 8.14286 0 7.61756 0 6.96956V5.10187C0 4.45387 0.521798 3.92857 1.16547 3.92857H3.0207C3.66437 3.92857 4.18617 4.45387 4.18617 5.10187V6.96956Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0618 3.04099C12.0618 3.68898 11.54 4.21429 10.8964 4.21429H9.04113C8.39746 4.21429 7.87567 3.68898 7.87567 3.04099V1.1733C7.87567 0.525302 8.39746 0 9.04113 0H10.8964C11.54 0 12.0618 0.525302 12.0618 1.1733V3.04099Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 6.96956C19.9375 7.61756 19.4157 8.14286 18.772 8.14286H16.9168C16.2731 8.14286 15.7513 7.61756 15.7513 6.96956V5.10187C15.7513 4.45387 16.2731 3.92857 16.9168 3.92857H18.772C19.4157 3.92857 19.9375 4.45387 19.9375 5.10187V6.96956Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06428 7.78571H3.19284V15.2143H1.06428V7.78571Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7447 7.78571H18.8732V15.2143H16.7447V7.78571Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38127 17.2022L3.34762 15.2929L9.92236 18.6654L8.95601 20.5747L2.38127 17.2022Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0796 3.27877L11.0459 1.36947L17.6206 4.74198L16.6543 6.65127L10.0796 3.27877Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95601 1.3539L9.92236 3.2632L3.34762 6.6357L2.38127 4.7264L8.95601 1.3539Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6543 15.2773L17.6206 17.1866L11.0459 20.5591L10.0796 18.6498L16.6543 15.2773Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorral);
export default __webpack_public_path__ + "static/media/Corral.d7278e66b70a4aebcb8daf9017665608.svg";
export { ForwardRef as ReactComponent };